/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { inject } from '@angular/core';
import { PrintCommand } from './print.command';
import { MatDialog } from '@angular/material/dialog';

export function printFactory() {
    const command = new PrintCommand();
    command.setDependencies({
        dialog: inject(MatDialog),
    });
    return command;
}
